import { render, staticRenderFns } from "./WebsiteSettingsList.vue?vue&type=template&id=50d18631&scoped=true&"
import script from "./WebsiteSettingsList.vue?vue&type=script&lang=js&"
export * from "./WebsiteSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteSettingsList.vue?vue&type=style&index=0&id=50d18631&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d18631",
  null
  
)

export default component.exports